module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-circle-down-d35502f1553050a8ac309cd58177e729.svg";